import React from 'react';

function accuracyClass(pct) {
  if (pct === null || pct === undefined) return 'text-text-muted';
  if (pct < 40) return 'text-red';
  if (pct < 70) return 'text-amber';
  return 'text-green';
}

export default function DrillStats({ stats }) {
  const safe = stats || {};
  const completed = safe.total_attempted ?? 0;
  const correct = safe.total_correct ?? 0;
  const accuracy = safe.accuracy_pct;
  const topicsTouched = safe.topics_touched ?? 0;
  const today = safe.attempted_today ?? 0;

  const cards = [
    { label: 'Drills completed', value: completed, cls: 'text-text-primary' },
    { label: 'Correct', value: correct, cls: 'text-text-primary' },
    {
      label: 'Accuracy',
      value: accuracy != null ? `${accuracy}%` : '—',
      cls: accuracyClass(accuracy),
    },
    { label: 'Topics touched', value: topicsTouched, cls: 'text-text-primary' },
    { label: 'Today', value: today, cls: 'text-text-primary' },
  ];

  return (
    <div className="grid grid-cols-5 gap-sp-3 mb-sp-5">
      {cards.map((c) => (
        <div
          key={c.label}
          className="bg-bg-card rounded-r-xl border border-border-soft px-sp-4 py-sp-3"
        >
          <p className="text-xs font-medium text-text-muted mb-sp-1">{c.label}</p>
          <p className={`text-2xl font-bold ${c.cls}`}>{c.value}</p>
        </div>
      ))}
    </div>
  );
}
